"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharingActionType = void 0;
let SharingActionType = exports.SharingActionType = /*#__PURE__*/function (SharingActionType) {
  /**
   * This is used for example for E-mail.
   * Final sharing link value is set directly to
   * window.loacation.href. According to the URL
   * scheme used in the link, a proper associated
   * system application get's opened. The URL in
   * browser's address bar will not get changed.
   */
  SharingActionType["DirectNavigation"] = "DirectNavigation";
  /**
   * For some vendors like copy link, WeChat etc., the URL scheme
   * used used in the final sharing link can't be
   * successfully opened via browser. Some applications
   * enable scanning the link value from displayed QR code
   * for finalizing the sharing process.
   */
  SharingActionType["CopyLinkDialog"] = "CopyLinkDialog";
  /**
   * Default behavior for most sharing vendors.
   * A new browser popup window or tab will be opened
   * and the sharing process is finalized in it.
   */
  SharingActionType["NewWindow"] = "NewWindow";
  return SharingActionType;
}({});